import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';

import { CurationService } from './../../../common/components/curation-modal/services/curation.service';
import { Environment, ENVIRONMENT_TOKEN } from '../../../core/environment.service';
import { CurationAdvocateData } from '../../../common/components/curation-modal/models/curation.model';

@Injectable({
    providedIn: 'root'
})
export class TimelineCurationService {

    constructor(
        private http: HttpClient,
        private curationService: CurationService,
        @Inject(ENVIRONMENT_TOKEN) private environment: Environment
    ) { }

    getCurationAdvocateData(propertyUUID: string, guestUUID: string): Observable<CurationAdvocateData> {
        const url = `${this.environment.apiV1BaseUrl}api/${propertyUUID}/properties/${propertyUUID}/advocates/${guestUUID}`;
        return this.http.get<CurationAdvocateData>(url).pipe(
            map(data => this.curationService.transformDetailsResponse(data))
        );
    }

    changeReservation(propertyUUID: string, guestUUID: string, data) {
        const url = `${this.environment.apiV1BaseUrl}api/${propertyUUID}/properties/${propertyUUID}/advocates/${guestUUID}`;
        return this.http.put(url, data);
    }

    sendEmailCertificate(propertyUUID: string, guestUUID: string, id: string, data = {}) {
        const url = `${this.environment.apiV1BaseUrl}api/${propertyUUID}/properties/${propertyUUID}/guests/${guestUUID}/certificates/${id}/send-email`;
        return this.http.post(url, data);
    }

    saveCertificateExpirationDate(propertyUUID: string, guestUUID: string, id: string, data = {}) {
        const url = `${this.environment.apiV1BaseUrl}api/${propertyUUID}/properties/${propertyUUID}/guests/${guestUUID}/certificates/${id}`;
        return this.http.put(url, data);
    }

}
